import React, { useEffect, useState } from "react";
import $ from "jquery";
import EloquaIntegration from "../../components/createProject/EloquaIntegration";
import MarketoRestIntegration from "../../components/createProject/MarketoRestIntegration";
import BrightcoveIntegration from "../../components/createProject/BrightcoveIntegration";
import PardotIntegration from "../../components/createProject/PardotIntegration";
import VidyardIntegration from "../../components/createProject/VidyardIntegration";
import UberflipIntegration from "../../components/createProject/UberflipIntegration";
import ExactTargetIntegration from "../../components/createProject/ExactTargetIntegration";
import StaticAssets from "../../components/createProject/StaticAssets";
import Constants from "../../Constants";
import { useSelector, useDispatch } from "react-redux";
import { updateProjectRequestIntegrationValue } from "../../redux/reducers/ProjectRequestIntegrationSlice";
import { setSelectedTreeData, removeSelectedTreeDataTargetLang } from "../../redux/reducers/TreeSlice"

const ProjectRequestIntegration = (props) => {
  const [showLanguagePage, setShowLanguagePage] = useState(false);

  const EloquaIntegrationMemo = React.memo(EloquaIntegration);
  const MarketoRestIntegrationMemo = React.memo(MarketoRestIntegration);
  const BrightcoveIntegrationMemo = React.memo(BrightcoveIntegration);
  const StaticAssetsMemo = React.memo(StaticAssets);
  const PardotIntegrationMemo = React.memo(PardotIntegration);
  const VidyardIntegrationMemo = React.memo(VidyardIntegration);
  const UberflipIntegrationMemo = React.memo(UberflipIntegration);
  const ExactTargetIntegrationMemo = React.memo(ExactTargetIntegration);

  const changeShowLanguagePage = (value) => {
    setShowLanguagePage(value);
  }

  return (
    <div className="lightbox-panel eloqua-request-popup" aria-labelledby="selectIntegration" aria-modal="true" role="dialog">
      <div className="inner-lightbox-panel pb-0" style={{ maxWidth: "95%" }}>
        <div className="modal-header flex padd-lr">
          <h5 id="selectIntegration">Select Your {props.contentName} Assets</h5>
        </div>
      
        <div id="eloqua-request">
          {!showLanguagePage ? (
            (() => {
              switch (props.contentType) {
                case Constants.MARKETOREST:
                  return <MarketoRestIntegrationMemo isProjectRequest = "true" projectRequestId={props.projectRequestId} department={props.department} />;
                case Constants.ELOQUA:
                  return <EloquaIntegrationMemo isProjectRequest = "true" projectRequestId={props.projectRequestId} />;
                case Constants.BRIGHTCOVE:
                  return <BrightcoveIntegrationMemo isProjectRequest = "true" projectRequestId={props.projectRequestId} department={props.department} />;
                case Constants.PARDOT:
                  return <PardotIntegrationMemo isProjectRequest = "true" projectRequestId={props.projectRequestId} />;
                case Constants.VIDYARD:
                  return <VidyardIntegrationMemo isProjectRequest = "true" projectRequestId={props.projectRequestId} />;
                case Constants.UBERFLIP:
                  return <UberflipIntegrationMemo isProjectRequest = "true" projectRequestId={props.projectRequestId} />;
                case Constants.EXACTTARGET:
                  return <ExactTargetIntegrationMemo isProjectRequest = "true" projectRequestId={props.projectRequestId} />;
                default:
                  return "";
              }
            })()
          ) : (
            <StaticAssetsMemo />
          )}
        </div>
        <ProjectRequestIntegrationFooter setShowLanguagePage={changeShowLanguagePage} contentType={props.contentType}/>
        
      </div>
    </div>
  );
}

const ProjectRequestIntegrationFooter = (props) => {

  const dispatch = useDispatch();

  const sourceLanguageRedux = useSelector((reduxStore) => reduxStore.source_language_for_project_creation).value;
  const targetLanguageRedux = useSelector((reduxStore) => reduxStore.target_language_for_project_creation).value;
  const selectedTreeData = useSelector((reduxStore) => reduxStore.tree_structure).selectedTreeData;
  const treeValueRedux = useSelector((redux) => redux.tree_structure).treeValue;

  const dispatchToProjectRequestIntegrationRedux = (type, value) => {
    dispatch(
      updateProjectRequestIntegrationValue({
        type: type,
        value: value,
      })
    );
  };

  const [showLanguagePage, setShowLanguagePage] = useState(props.showLanguagePage);

  let disableDoneButton = false;
  if (
    (!sourceLanguageRedux || Object.keys(sourceLanguageRedux)?.length === 0) || 
    !targetLanguageRedux || targetLanguageRedux?.length === 0 || 
    (!targetLanguageRedux || Object.keys(targetLanguageRedux)?.length === 0)
) {
    disableDoneButton = true;
  }
  let disableNextButton = false;
  if (selectedTreeData?.length === 0) {
    disableNextButton = true;
  }

  const cancelIntegrationModel = () => {
    updateShowLanguagePage(false);
    document.body.classList.remove("modal-open");
    $(".integration-check-input").prop("checked", false);
    dispatch(setSelectedTreeData([]))
  };

  const doneIntegrationModel = () => {
    updateShowLanguagePage(false);
    document.body.classList.remove("modal-open");
    $(".integration-check-input").prop("checked", false);
    dispatchToProjectRequestIntegrationRedux("selectedAssets", selectedTreeData);
    dispatchToProjectRequestIntegrationRedux("sourceLanguage", sourceLanguageRedux);
    dispatchToProjectRequestIntegrationRedux("targetLanguages", targetLanguageRedux);
    dispatchToProjectRequestIntegrationRedux("displayName", treeValueRedux.displayName);
    dispatchToProjectRequestIntegrationRedux("contentType", props.contentType);
    dispatch(setSelectedTreeData([]))
  };

  const handleKeyAddflow = (event) => {
    if (event.key === Constants.TAB) {
      if (event.shiftKey === false) {
        event.preventDefault();
        $("#dasboardBtn").trigger("focus");
      }
    }
  };

  const updateShowLanguagePage = (value) => {
    if(!value && selectedTreeData.length>0)
    {
      dispatch(removeSelectedTreeDataTargetLang({index: 0, langIndex: 0, language: {}}))
    }
    props.setShowLanguagePage(value);
    setShowLanguagePage(value)
  }

  return (
    <div className="modal-footer modal-footer-border flex px-22">
      {showLanguagePage && 
        <div className="left flex">
          <div>
            <button className="btn btn-bold first-focus" aria-label="Back" onKeyDown={(event) => handleKeyAddflow(event)} onClick={() => updateShowLanguagePage(false)}>
              Back
            </button>
          </div>
        </div>
      }
      <button className="btn btn-bold first-focus" aria-label="Cancel" onKeyDown={(event) => handleKeyAddflow(event)} onClick={() => cancelIntegrationModel()}>
        Cancel
      </button>
      {(!showLanguagePage && $(".integration-asset-view").length === 0) &&
        <button className="btn btn-bold first-focus" aria-label="Next" onKeyDown={() => handleKeyAddflow()} disabled={disableNextButton} onClick={() => updateShowLanguagePage(true)}>
          Next
        </button>
      }
      {showLanguagePage && 
        <button className="btn btn-bold first-focus" aria-label="Done" onKeyDown={() => handleKeyAddflow()} disabled={disableDoneButton} onClick={() => doneIntegrationModel()}>
          Done
        </button>
      }
    </div>
  );
}

export default ProjectRequestIntegration;
